import type { DeleteActionTypeResponse } from '@/domains/actionType/actionType.entity';
import type { ActionTypeRepository } from '@/domains/actionType/actionType.repository';

/**
 * Use Case para eliminar un tipo de acción existente del sistema.
 *
 * Funcionalidad:
 * - Elimina un tipo de acción del catálogo de acciones académicas disponibles
 * - Remueve permanentemente el tipo de acción del sistema
 * - Persiste la eliminación mediante el repositorio
 *
 * Responsabilidades:
 * - Validar el código del tipo de acción antes de eliminar
 * - Coordinar la eliminación con el repositorio
 * - Actuar como intermediario entre dominio e infraestructura
 * - Manejar posibles dependencias o restricciones de eliminación
 */
export class DeleteActionTypeUseCase {
  private repository: ActionTypeRepository;

  /**
   * Inicializa el UseCase con las dependencias necesarias.
   *
   * @param repository - Repositorio que implementa ActionTypeRepository para operaciones CRUD
   */
  constructor(repository: ActionTypeRepository) {
    this.repository = repository;
  }

  /**
   * Ejecuta la eliminación de un tipo de acción.
   *
   * @param cod_tipo_accion - Código único del tipo de acción a eliminar
   */
  async execute(cod_tipo_accion: number): Promise<DeleteActionTypeResponse> {
    return await this.repository.deleteActionType(cod_tipo_accion);
  }
}
